var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSignButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 33,
    viewBox: "0 0 33 33",
    width: 33,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16.5 30.9375c3.8291 0 7.5013-1.5211 10.2089-4.2286 2.7075-2.7076 4.2286-6.3798 4.2286-10.2089s-1.5211-7.5013-4.2286-10.20885c-2.7076-2.70756-6.3798-4.22865-10.2089-4.22865s-7.5013 1.52109-10.20885 4.22865c-2.70756 2.70755-4.22865 6.37975-4.22865 10.20885s1.52109 7.5013 4.22865 10.2089c2.70755 2.7075 6.37975 4.2286 10.20885 4.2286zm0 2.0625c4.3761 0 8.5729-1.7384 11.6673-4.8327 3.0943-3.0944 4.8327-7.2912 4.8327-11.6673s-1.7384-8.57291-4.8327-11.66726c-3.0944-3.09435-7.2912-4.83274-11.6673-4.83274s-8.57291 1.73839-11.66726 4.83274-4.83274 7.29116-4.83274 11.66726 1.73839 8.5729 4.83274 11.6673c3.09435 3.0943 7.29116 4.8327 11.66726 4.8327z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.7695 23.4177v-6.752-5.623c0-1.46024 0 0 0-1.46024.0959-.09588.2097-.17194.335-.22383s.2596-.0786.3952-.0786.2698.02671.3951.0786.2391.12795.335.22383l6.1875 6.18754c.096.0958.1722.2096.2242.3348.052.1253.0787.2596.0787.3953 0 .1356-.0267.2699-.0787.3952s-.1282.2391-.2242.3349l-6.1875 6.1875c-.0958.096-.2096.1722-.3349.2242s-.2596.0788-.3952.0788c-.1357 0-.27-.0268-.3953-.0788s-.2391-.1282-.3349-.2242z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.28125 16.5c0-.2735.10865-.5358.30205-.7292.19339-.1934.4557-.302.7292-.302h10.3125c.2735 0 .5358.1086.7292.302s.302.4557.302.7292-.1086.5358-.302.7292-.4557.302-.7292.302h-10.3125c-.2735 0-.53581-.1086-.7292-.302-.1934-.1934-.30205-.4557-.30205-.7292z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignButton);
export default __webpack_public_path__ + "static/media/sign-button.7d25dec8.svg";
export { ForwardRef as ReactComponent };